import ic_edit from "../../assets/icons/ic_edit.svg";
import { useEffect, useRef, useState } from "react";
import yoga from "../../assets/images/yoga.png";
import sports_fitness from "../../assets/images/sports_fitness.png";
import ic_tick from "../../assets/icons/ic_tick.svg";
import physiotherapy from "../../assets/images/physiotherapy.png";
import Button from "../basic/Button";
import { useAuthContext } from "../../context/AuthContext";
import { changePassword, updateAvatar, updateUserProfile } from "../../api/api";
import { toast } from "react-toastify";
import { Dialog } from "@headlessui/react";
import ic_close from "../../assets/icons/ic_close.svg";
import IconButton from "../basic/IconButton";
import CustomDialog from "../basic/Dialog";
import ImageCropDialog from "./ImageCropDialog";

function ChangePasswordDialog({ show, close }) {
  const [currentPasswrd, setCurrentPassword] = useState();
  const [newPassword, setNewPassword] = useState();
  const [confirmPasswrd, setConfirmPassword] = useState();

  async function performChangePassword() {
    const response = await changePassword(currentPasswrd, newPassword);
    if (response.success) {
      toast("Password Updated", { type: "success" });
      close();
    } else {
      toast("Password Update Failed", { type: "error" });
    }
  }

  return (
    <CustomDialog show={show} close={close}>
      <Dialog.Panel
        className={`w-full max-w-xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all`}
      >
        <div className="w-full flex justify-end items-end">
          <IconButton
            icon={ic_close}
            className="shadow-xl flex justify-end"
            onClick={() => close()}
          />
        </div>
        <p className="text-2xl font-bold text-center text-gray-900">
          Change Password
        </p>

        <input
          className="mt-3 px-4 py-3 rounded-lg border-[1px] border-gray-300 w-full"
          placeholder="Current Password"
          type={"password"}
          onChange={(e) => {
            setCurrentPassword(e.target.value);
          }}
        />
        <input
          className="mt-3 px-4 py-3 rounded-lg border-[1px] border-gray-300 w-full"
          placeholder="New Password"
          type={"password"}
          onChange={(e) => {
            setNewPassword(e.target.value);
          }}
        />
        <input
          className="mt-3 px-4 py-3 rounded-lg border-[1px] border-gray-300 w-full"
          placeholder="Confirm Password"
          type={"password"}
          onChange={(e) => {
            setConfirmPassword(e.target.value);
          }}
        />
        <Button
          onClick={() => {
            if (newPassword == confirmPasswrd) performChangePassword();
            else toast("Password do not match");
          }}
          type="primary"
          className={"w-full mt-6"}
        >
          Update Password
        </Button>
      </Dialog.Panel>
    </CustomDialog>
  );
}

function EditProfilePage() {
  const auth = useAuthContext();
  const [avatar, setAvatar] = useState(auth.state.user.avatar);
  const [name, setName] = useState(auth.state.user.fullname);
  const [aboutMe, setAboutMe] = useState(auth.state.user.aboutme);
  const [email, setEmail] = useState(auth.state.user.email);
  const [mobile, setMobile] = useState(auth.state.user.mobile);
  const [selected, setSelected] = useState([auth.state.user.programName]);
  const [showChangePassword, setShowChangePassword] = useState(false);

  const [showImageCropper, setShowImageCropper] = useState(false);
  const [profilePicture, setProfilePicture] = useState();
  const imagePickerRef = useRef();

  async function updateProfile() {
    const data = {
      update: JSON.stringify({
        fullname: name,
        aboutme: aboutMe,
        email: email,
        mobile: mobile,
      }),
    };
    const response = await updateUserProfile(data);
    auth.updateUser();
    toast("Profile details updated");
  }

  async function uploadAvatar(image) {
    let data = new FormData();
    data.append("avatar", image);
    const response = await updateAvatar(data);
    auth.updateUser();
    if (response.success) {
      toast("Avatar Updated");
      return true;
    } else {
      toast("Avatar update failed. Try a different image");
      return false;
    }
  }

  const options = [
    {
      id: "SportsNFitness",
      title: "Sports Fitness",
      comingSoon: false,
      image: sports_fitness,
    },
    {
      id: "yoga",
      title: "Yoga",
      comingSoon: true,
      image: yoga,
    },
    {
      id: "physiotherapy",
      title: "Physiotherapy",
      comingSoon: true,
      image: physiotherapy,
    },
  ];

  return (
    <div className="flex flex-col w-full h-full px-10 md:px-20 py-12 bg-customGray-50">
      <ImageCropDialog
        show={showImageCropper}
        close={async (croppedImageBlob) => {
          setShowImageCropper(false);
          const croppedImageUrl = window.URL.createObjectURL(croppedImageBlob);
          const file = new File([croppedImageBlob], "image.png", {
            type: croppedImageBlob.type,
          });
          const success = await uploadAvatar(file);
          if (success) {
            setAvatar(croppedImageUrl);
          }
        }}
        image={profilePicture}
        aspectRatio={1}
      />
      <ChangePasswordDialog
        show={showChangePassword}
        close={() => setShowChangePassword(false)}
      />
      <p className="font-bold text-2xl">Edit Profile</p>
      <div className="flex flex-col w-3/4 self-center justify-center items-center">
        <div
          className="w-24 h-24 rounded-full bg-red-900  flex items-center justify-center relative"
          onClick={() => {
            imagePickerRef.current.click();
          }}
        >
          <div
            style={{ backgroundImage: `url('${avatar}')` }}
            className="w-20 h-20 bg-cover bg-center rounded-full  bg-white"
          />
          <img
            src={ic_edit}
            className={"p-2 absolute bg-red-900 rounded-full right-0 bottom-2"}
          />
        </div>
        <input
          type="file"
          id="file"
          ref={imagePickerRef}
          className="hidden"
          onChange={(e) => {
            const image = e.target.files[0];
            if (image) {
              setProfilePicture(image);
              setShowImageCropper(true);
            }
          }}
        />
        {/* <div className="flex flex-row w-full space-x-24 mt-14">
          <div className="flex-1 ">
            <p className="text-customGray-200 font-bold ">First Name</p>
            <input className="rounded-md mt-2 px-3 py-2 drop-shadow-md w-full" 
            value={firstName}
            onChange={(e)=>{
              setFirstName(e.target.value);
            }} />
          </div>
          <div className="flex-1">
            <p className="text-customGray-200 font-bold ">Last Name</p>
            <input className="rounded-md mt-2 px-3 py-2 drop-shadow-md w-full" value={lastName} 
            onChange={(e)=>{
              setLastName(e.target.value);
            }}/>
          </div>
        </div> */}

        <div className="w-full">
          <p className="text-customGray-200 font-bold mt-14">Full Name</p>
          <input
            className="rounded-md mt-2 px-3 py-2 drop-shadow-md w-full"
            multiple
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </div>

        <div className="w-full">
          <p className="text-customGray-200 font-bold mt-14">About Me</p>
          <input
            className="rounded-md mt-2 px-3 py-2 drop-shadow-md w-full"
            multiple
            value={aboutMe}
            onChange={(e) => {
              setAboutMe(e.target.value);
            }}
          />
        </div>
        <div className="w-full">
          <p className="text-customGray-200 font-bold mt-14">Email</p>
          <input
            className="rounded-md mt-2 px-3 py-2 drop-shadow-md w-full"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
        </div>
        <div className="w-full">
          <p className="text-customGray-200 font-bold mt-14">Contact number</p>
          <input
            className="rounded-md mt-2 px-3 py-2 drop-shadow-md w-full"
            type="number"
            value={mobile}
            onChange={(e) => {
              setMobile(e.target.value);
            }}
          />
        </div>
        <div className="w-full">
          <div className="flex flex-row">
            <p className="text-customGray-200 font-bold mt-14 flex-1">
              Password
            </p>
            <p
              className="text-customGray-200 font-bold mt-14 hover:cursor-pointer"
              onClick={() => {
                setShowChangePassword(true);
              }}
            >
              Edit
            </p>
          </div>
          <input
            className="rounded-md mt-2 px-3 py-2 drop-shadow-md w-full"
            type={"password"}
            value="12345678"
            contentEditable={false}
          />
        </div>
        <div className="w-full">
          <p className="text-customGray-200 font-bold mt-14">Programs</p>
          <div className={"grid gap-3 grid-cols-1  md:grid-cols-3 "}>
            {options.map((option) => (
              <div
                className={`flex flex-col col-span-1 border-2 rounded-xl realtive p-4 lg:h-80  bg-no-repeat bg-cover
                ${
                  selected.includes(option.id)
                    ? "border-red-800"
                    : "border-white"
                }`}
                onClick={() => {
                  if (selected.includes(option.id)) {
                    setSelected((prevState) =>
                      prevState.filter((value) => {
                        return value != option.id;
                      })
                    );
                  } else setSelected((prevState) => [...prevState, option.id]);
                }}
                style={{ backgroundImage: `url(${option.image})` }}
              >
                <div className="flex flex-1 flex-col ">
                  <div className="flex justify-end ">
                    <div
                      className={` border-2 max-w-max p-2  flex-shrink-0 ${
                        selected.includes(option.id)
                          ? "border-red-800"
                          : " border-white"
                      }`}
                    >
                      <img
                        src={ic_tick}
                        className={`${
                          selected.includes(option.id) ? "vidible" : "invisible"
                        }`}
                      />
                    </div>
                  </div>
                  <div className="flex-1 mt-20" />
                  {option.comingSoon && (
                    <p className=" px-3 py-1 lg:py-2 bg-gray-200 max-w-max rounded-full text-white font-bold text-xs">
                      Coming Soon
                    </p>
                  )}
                  <p className="font-bold text-white lg:text-xl">
                    {option.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <Button
          onClick={() => {
            updateProfile();
          }}
          type="primary"
          className={"self-end mt-14"}
        >
          Save
        </Button>
      </div>
    </div>
  );
}

export default EditProfilePage;
